// Canvas endpoints live on the actions API, same base URL the rest of the
// webapp uses (matches useHttpQuery's default and the other VITE_ACTIONS_BASE_URL callers).
const getCanvasApiBaseUrl = (): string =>
    import.meta.env.VITE_ACTIONS_BASE_URL || 'http://localhost:8080';

export default getCanvasApiBaseUrl;
